import React from "react";

const Mission = React.forwardRef((props, ref) => {
  return (
    <div
      ref={ref}
      className="flex items-center justify-center py-8 bg-[#01579b]"
    >
      <div className="w-[90%] flex flex-col gap-7">
        <div className=" flex flex-col gap-4">
          <div className=" grid grid-rows md:grid-cols-2 text-[#38761d] bg-white p-4">
            <div>
              <h1 className="text-2xl font-bold text-red-600">
                The problem we are trying to solve
              </h1>
              <h2 className="text-xl font-semibold">
                ENERGY POVERTY & AFFORDABILITY.
              </h2>
              <p className="">
                Access to clean cooking energy is limited or non-existent in
                many low-income communities in Nigeria. The increase cost of
                clean energy for cooking (e.g LPG ) remains an obstacle to the
                rate of adoption in low-income communities. Therefore, majority
                in these communities still rely on fossil fuel sources like
                kerosene and traditional biomass fuels like firewood and
                charcoal for cooking.
              </p>
            </div>
            <div
              className="w-full md:h-full h-[300px]"
              style={{
                backgroundImage: `url('/images/firewood.avif')`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                backgroundSize: "cover",
              }}
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default Mission;
